import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import FrameSlider from '../../../../../id8/components/frames/slider/FrameSlider';
import DemoSlide from './slide/DemoSlide';

import scss from './FrameCard.module.scss';

function FrameCard({ frameData, onPreview, onLike, onShowSourceImage }) {
  const { t } = useTranslation('id8');

  const { ideaHeadline, advertisingStatement, copy } = frameData;

  const handlePreview = () => {
    onPreview(frameData);
  };

  const handleShowSourceImage = () => {
    onShowSourceImage(frameData);
  };

  return (
    <div className={scss.card}>
      <FrameSlider
        images={[frameData]}
        onPreview={handlePreview}
        onLike={onLike}
        isGenerating={false}
        onShowSourceImage={handleShowSourceImage}
        Slide={DemoSlide}
      />

      <div className={scss.content}>
        <span className={scss.title}>
          <b>{t('ideaHeadline')}: </b>
          {ideaHeadline}
        </span>

        <div className={scss.textContent}>
          <span className={scss.subTitle}>{copy}</span>
          <span className={scss.subTitle}>{advertisingStatement}</span>
        </div>
      </div>
    </div>
  );
}

export default memo(FrameCard, (prevProps, nextProps) => {
  return (
    prevProps.frameData.sessionId === nextProps.frameData.sessionId &&
    prevProps.frameData.reaction === nextProps.frameData.reaction &&
    prevProps.frameData.sourceImageKey === nextProps.frameData.sourceImageKey
  );
});

export const EMPTY_IMAGE = { ideaHeadline: '-/-', copy: '-/-', advertisingStatement: '-/-' };
